import { PageLoadingIndicator } from '@wrisk/ui-components'
import React, { FunctionComponent, PropsWithChildren } from 'react'

import { useApiErrorHandlingAsync } from '../../../../hooks/auth'
import { usePrincipal } from '../../../authentication'
import { PaymentMethodsProvider } from '../../policy/billing/PaymentMethodsProvider'
import { useProposal } from '../ProposalProvider'

export const PaymentManager: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const { apiClient } = usePrincipal()
  const { proposal } = useProposal()

  const { result, loading } = useApiErrorHandlingAsync(
    async () => await apiClient.getPaymentMethods(),
    [proposal],
  )

  if (loading || !result) {
    return <PageLoadingIndicator />
  }

  return (
    <PaymentMethodsProvider paymentMethods={result}>{children}</PaymentMethodsProvider>
  )
}
